import { render, staticRenderFns } from "./BaseSmallInput.vue?vue&type=template&id=01dbfc67&scoped=true&"
import script from "./BaseSmallInput.vue?vue&type=script&lang=js&"
export * from "./BaseSmallInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseSmallInput.vue?vue&type=style&index=0&id=01dbfc67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dbfc67",
  null
  
)

export default component.exports